module.exports = __webpack_public_path__ + "img/a.d7674aea.svg";